export class MyUploadImageAdapter {
    loader: any;
    vhImage: any;
    path: any;
    w:number;
    h:number;
    constructor( loader:any, vhImage:any, path?:any,  w?:any, h?:any ) {
      // The file loader instance to use during the upload.
      this.loader = loader;
      this.vhImage = vhImage;   
      this.path = path;        
      this.w = w;
      this.h = h;
      if((this.path === null) || (this.path === undefined)){
        this.path = '';//Trên server sẽ ghi file ảnh lên thử mục gốc (root)
      }   }
    
    // Starts the upload process.
    upload() {      
      return this.loader.file
          .then( (file:any) => new Promise( ( resolve, reject ) => {                    
            if((this.w === null) || (this.w === undefined) || (this.h === null) || (this.h === undefined)){                       
              this.vhImage.getImageFromDesktop(file, this.path).then(
                (rsp:any) => {                     
                  let photoURL = '';
                  if(rsp.vcode ===0) photoURL = rsp.data;
                  resolve({
                    default: photoURL
                  })						  
                            
                },(error:any) => {					
                  console.log('Image was failed', error);
                }
              );
            }else{              
              this.vhImage.getThumbnailFromDesktop(file, this.w, this.h, this.path).then(
                (rsp:any) => {                     
                  let photoURL = '';
                  if(rsp.vcode ===0) photoURL = rsp.data; 	                   
                  resolve({
                    default: photoURL
                  })						  
                            
                },(error:any) => {					
                  console.log('------------Image was failed',error);
                }
              );
            }            
          }));
    }
}